// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fe_S","rootMobile":"styles_rootMobile__1lDjJ"};